import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-bpams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-bpams.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { CreateApplicationDetailsBpamsConstants } from "./create-application-details-bpams.constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { AppControllerService } from "../../../../app-controller.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
export let CreateApplicationDetailsBpamsComponent = class CreateApplicationDetailsBpamsComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    changeDetectorRefs;
    detailsForm;
    validationMessages = CreateApplicationDetailsBpamsConstants.VALIDATION_MESSAGES;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    descriptionFormControlName = CreateApplicationDetailsBpamsConstants.DESCRIPTION_FORM_CONTROL_NAME;
    descriptionLabel = CreateApplicationDetailsBpamsConstants.DESCRIPTION_LABEL;
    isMinorBuildingWorkLabel = CreateApplicationDetailsBpamsConstants.IS_MINOR_BUILDING_WORK_LABEL;
    sectorLabel = CreateApplicationDetailsBpamsConstants.SECTOR_LABEL;
    isRDPLabel = CreateApplicationDetailsBpamsConstants.IS_RDP_LABEL;
    buildingUseLabel = CreateApplicationDetailsBpamsConstants.BUILDING_USE_LABEL;
    isMinorBuildingWorkFormControlName = CreateApplicationDetailsBpamsConstants.IS_MINOR_BUILDING_WORK_FORM_CONTROL_NAME;
    sectorFormControlName = CreateApplicationDetailsBpamsConstants.SECTOR_FORM_CONTROL_NAME;
    isRDPFormControlName = CreateApplicationDetailsBpamsConstants.IS_RDP_FORM_CONTROL_NAME;
    buildingUseFormControlName = CreateApplicationDetailsBpamsConstants.BUILDING_USE_FORM_CONTROL_NAME;
    yesNoOptions = [];
    sectorOptions = [];
    buildingUseOptions = [];
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appController, changeDetectorRefs) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        if (this.aflaModuleStrategyService.lookups.has("sectorOptions")) {
            this.sectorOptions = this.aflaModuleStrategyService.lookups.get("sectorOptions");
            this.buildingUseOptions = this.aflaModuleStrategyService.lookups.get("buildingUseOptions");
            this.yesNoOptions = [];
            // tslint:disable-next-line:forin
            for (const yesnoenumKey in SharedConstants.YES_NO_ENUM) {
                this.yesNoOptions.push(SharedConstants.YES_NO_ENUM[yesnoenumKey]);
            }
            this.subscribeToSelectedApplication();
        }
        else {
            this.getLookups();
        }
    }
    loadMetadata(stepMeta) {
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("detailsForm");
        this.detailsForm = form;
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.applicationCreateService.moduleID} and (name eq 'BuildingUse' or name eq 'BuildingSector')`,
        };
        this.applicationCreateService
            .getLookupsObservable(params)
            .subscribe((response) => this.onGetLookupsCompleted(response), (error) => {
            this.appController.handleServerErrorMessage(CreateApplicationDetailsBpamsConstants.STEP_TITLE, error, CRUDOperation.Get);
        });
    }
    onGetLookupsCompleted(response) {
        const buildingUse = [];
        const sector = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "BuildingUse") {
                    buildingUse.push(JSON.parse(item.content));
                }
                if (item.name === "BuildingSector") {
                    sector.push(JSON.parse(item.content));
                }
            });
        }
        this.yesNoOptions = [];
        for (const yesnoenumKey in SharedConstants.YES_NO_ENUM) {
            this.yesNoOptions.push(SharedConstants.YES_NO_ENUM[yesnoenumKey]);
        }
        this.aflaModuleStrategyService.lookups.set("buildingUseOptions", buildingUse);
        this.buildingUseOptions = buildingUse;
        this.aflaModuleStrategyService.lookups.set("sectorOptions", sector);
        this.sectorOptions = sector;
        this.changeDetectorRefs.detectChanges();
        this.subscribeToSelectedApplication();
    }
    subscribeToSelectedApplication() {
        this.cleanupAfterDestroy(this.selectedApplicationService.$selectedApplication).subscribe((application) => {
            if (application) {
                this.setApplicationDetails(application);
            }
        });
    }
    setApplicationDetails(application) {
        // checks the application has application details set
        if (application.description) {
            this.detailsForm.get(this.descriptionFormControlName).setValue(application.description);
        }
        if (application.isMinorBuildingWork) {
            this.detailsForm.get(this.isMinorBuildingWorkFormControlName).setValue(application.isMinorBuildingWork);
        }
        if (application.sector) {
            this.detailsForm.get(this.sectorFormControlName).setValue(application.sector);
        }
        if (application.isRdp) {
            this.detailsForm.get(this.isRDPFormControlName).setValue(application.isRdp);
        }
        if (application.buildingUse) {
            this.detailsForm.get(this.buildingUseFormControlName).setValue(application.buildingUse);
        }
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
CreateApplicationDetailsBpamsComponent = __decorate([
    Component({
        selector: "app-create-application-details-bpams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsBpamsComponent);
